import { render, staticRenderFns } from "./PropertySelector.vue?vue&type=template&id=45ab3f36"
import script from "./PropertySelector.vue?vue&type=script&lang=js"
export * from "./PropertySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports